import {
  Directive,
  ElementRef,
  forwardRef,
  Inject,
  Injector,
  Renderer2,
} from '@angular/core';
import {
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import {PatternlibControlValueAccessorValueBase} from './accessor-base';

@Directive({
  selector: 'patternlib-checkbox,patternlib-toggle',
  host: {
    '(lhChange)': "handleChangeEvent($event.target.checked)",
  },
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => PatternlibCheckControlValueAccessor),
    multi: true,
  }],
})
export class PatternlibCheckControlValueAccessor extends PatternlibControlValueAccessorValueBase {
  constructor(
    renderer: Renderer2,
    @Inject(Injector) injector: Injector,
    elementRef: ElementRef,
  ) {
    super(renderer, injector, elementRef);
  }

  override writeValue(value: any): void {
    this._renderer.setProperty(this._elementRef.nativeElement, 'checked', value);
  }
}
